<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mhvXSD/tc-custom/9780253039415.jpg?1732167264622" alt="This image is the cover for the book Guide to the Contemporary Harp"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Guide to the Contemporary Harp
      </h1>
      <p class="bookDescription body article font2">
        <p></p><p>Harps and harp music have enjoyed a renaissance over the past century and today can be heard in a broad array of musical contexts. <i>Guide to the Contemporary Harp</i> is a comprehensive resource that examines the vibrant present-day landscape of the harp. The authors explore the instrument from all angles, beginning with organology; moving through composition, notation, and playing techniques; and concluding with the contemporary repertoire for the harp. The rapid diversification in these areas of harp performance is the result of both technological innovations in harp making, which have produced the electric harp and MIDI harp, and innovative composers and players. These new instruments and techniques have broadened the concept of what is possible and what constitutes harp music for today.<i> Guide to the Contemporary Harp </i>is an essential guide for any harpist looking to push the instrument and its music to new heights.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mathilde Aubat-Andrieu, Laurence Bancaud, Aurélie Barbé, Hélène Breschand
      </h2>
      
      <p class="authorDescription body article"><P><P>Mathilde Aubat-Andrieu is a harpist and cofounder of the association Les Signes de l'arc (The Signs of the Arch). She was awarded a gold medal and first prize in proficiency at the Music Conservatory in Troyes (France) and gives regular performances at reading-concerts, with chamber music ensembles and orchestra.</P><P></P><P>Laurence Bancaud is a harpist and cofounder of the association Les Signes de l'arc. She was awarded first prize at the CNSMD (Conservatoire National Supérieur de Musique et de Danse) and has a master's degree in musicology and specializes in contemporary music. She is author of <I>Tôn-Thât Tiêt: Dialogue Avec la Nature</I>.</P><P></P><P>Aurélie Barbé is a harpist, composer, and cofounder of the association Les Signes de l'arc. She was awarded a gold medal at the Music Conservatory in Caen (France) and a higher studies diploma in musicology. She is a teacher and performer, specializing in modal, minimalist and improvised music for both classical and electric harp.</P><P></P><P>Hélène Breschand is a harpist, composer, and cofounder of the association Les Signes de l'arc. She was awarded a gold medal and first prize in proficiency at the Conservatoire à Rayonnement Regional in Paris. She pursues her career as a soloist in the contemporary repertoire and in new creations, improvisation, and musical theatre.</P><P></P><P>Lilian Rossi has pursued an academic career and is the author of <I>Doctors and Nurses</I>. Jean Rossi is an administrative officer. Working as a team, they have translated numerous academic and literary works from French and German.</P></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4ca47ab8